<template>
  <v-sheet
    v-if="!finding.acbCloseDate"
    class="px-4 py-4 mr-5 mt-4 d-print-none"
    color="amber lighten-4"
    style="margin-left:140px"
    width="100%"
  >
    <Confirm ref="confirm" />

    <div class="text-h5 pb-2 px-1 brown--text text--darken-2">{{ dictionary['acbNotes'].longname }}</div>

    <v-layout column>
      <TextArea
        auto-grow
        class="mb-2"
        field="acbNotes"
        height="auto"
        :value="text"
        :placeholder="`Enter ${dictionary['acbNotes'].longname} here ...`"
        @change="change"
      />
      <v-layout align-center justify-space-between>
        <div v-if="finding.acbCompDate">
          {{ new Date().toIACSformat() }}
        </div>
        <div>
          <v-btn
            depressed
            color="primary"
            :loading="saving"
            :disabled="!(notesChanged)"
            @click="update"
          >
            Update Notes
          </v-btn>
          <v-btn
            v-if="finding.acbCompDate && canCloseFindings"
            class="ml-2"
            color="primary"
            depressed
            :loading="closing"
            :disabled="!(date)"
            @click="updateAndClose"
          >
            Close Finding
          </v-btn>
        </div>
      </v-layout>
    </v-layout>
  </v-sheet>
</template>

<script>
import { mdiHelpCircle } from "@mdi/js"

import { dictionary } from '@/models/finding'

import TextArea from '@/components/UI/forms/textarea'

export default {
  components: {
    TextArea
  },
  props: {
    finding: {
      type: Object,
      default() { return {} }
    },
    close: {
      type: Function
    }
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      dictionary,
      closing: false,
      saving: false,
      text: null
    }
  },
  computed: {
    canCloseFindings() {
      return this.$store.state.auth.user.canCloseFindings
    },
    notesChanged() {
      return this.text !== this.finding.acbNotes
    }
  },
  methods: {
    change({ field, value}) {
      if (field === 'acbNotes'){
        this.text = value
      }
      if (field === 'acbCloseDate'){
        this.date = value
      }
    },
    update() {
      this.saving = true
      const upd = {
        acbNotes: this.text,
        kind: 'Auditor Update'
      }
      this.finding.patch({ data: upd }).then(() => {
        this.$snotify.success('Notes Updated', 'Success!')
        this.saving = false
      }, error => {
        this.$snotify.error(error.message, 'Error')
        this.saving = false
      })
    },
    async updateAndClose() {

      // reference to the confirm dialog
      const confirm = this.$refs.confirm

      this.closing = true

      const result = await confirm.open(
        'Close Finding',
        `Are you sure you want to close ${this.finding.acbFindingFile} ?`,
        {
          acceptColor: 'primary',
          acceptLabel: 'Close Finding',
          cancelLabel: 'Cancel',
          color: 'primary',
          icon: mdiHelpCircle,
          width: 410
        }
      )

      if (result) {
        const upd = {
          acbClosedBy: this.$store.state.auth.user.name,
          acbCloseDate: this.date,
          kind: 'Auditor Closure'
        }
        if (this.notesChanged) {
          upd.acbNotes = this.text
        }
        await this.finding.patch({ data: upd }).then(() => {
          setTimeout(() => {
            this.closing = false
            this.$snotify.success('Finding Closed', 'Success!')
            this.close()
          }, 300)
        }, error => {
          this.$snotify.error(error.message, 'Error')
          this.saving = false
        })
      }
      this.closing = false
    }
  },
  watch: {
    finding: {
      handler (newVal){
        this.text = newVal.acbNotes
        this.date = (newVal.acbCloseDate
         ? new Date(newVal.acbCloseDate)
         : new Date()).toISOString().substr(0, 10)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
